/**
 * Compact turnaround time for PA / claims lists.
 * Prefers API `tat_seconds` + `received_at` / `processed_at`.
 */

export function formatTatDuration(seconds) {
  if (seconds == null || seconds === "") return "";
  const n = Number(seconds);
  if (!Number.isFinite(n) || n < 0) return "";
  const s = Math.floor(n);
  if (s < 60) return "<1m";
  const days = Math.floor(s / 86400);
  const hours = Math.floor((s % 86400) / 3600);
  const mins = Math.floor((s % 3600) / 60);
  if (days >= 1) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  if (hours >= 1) return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  return `${mins}m`;
}

function parseTs(value) {
  if (!value) return null;
  const t = new Date(value).getTime();
  return Number.isFinite(t) ? t : null;
}

export function tatFromRecord(record) {
  if (!record) return { label: "", pending: false, seconds: null };
  const received = record.received_at || null;
  if (received == null || received === "") {
    if (record.tat_seconds == null || record.tat_seconds === "") {
      return { label: "", pending: false, seconds: null };
    }
  }
  let seconds = record.tat_seconds != null && record.tat_seconds !== ""
    ? Number(record.tat_seconds)
    : null;
  const pending = Boolean(record.tat_pending);
  if (!Number.isFinite(seconds)) {
    const start = parseTs(received);
    const end = pending ? Date.now() : parseTs(record.processed_at);
    seconds = start != null && end != null ? Math.max(0, Math.floor((end - start) / 1000)) : null;
  }
  if (received == null && (seconds == null || !Number.isFinite(seconds))) {
    return { label: "", pending: false, seconds: null };
  }
  if (seconds == null || !Number.isFinite(seconds)) {
    return { label: "", pending, seconds: null };
  }
  return { label: formatTatDuration(seconds), pending, seconds };
}

export function formatTatLabel(record) {
  return tatFromRecord(record).label || "—";
}
